import React, { Fragment, useState, useEffect, useContext } from 'react';
import LaborCost from './LaborCost';
import TotalEstimation from './TotalEstimation';
import { ProjectContext } from '../../../../../../context/Project';
import { formatPrice } from '../../../../../../common/numberFormat';

function Totals() {
    const { projectMaterials } = useContext(ProjectContext);

    const [materialTotal, setMaterialTotal] = useState(0);
    const [materialsListVisible, setMaterialsListVisible] = useState(true);
        
    useEffect(() => {        
        setMaterialTotal(calculateMaterialsTotal(projectMaterials));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectMaterials]);

    const handleMaterialsDropdownClick = () => {
        setMaterialsListVisible(!materialsListVisible);
    }

    const calculateMaterialsTotal = (materials) => {
        let materialTotal = 0;

        for (let i in materials) {
            materialTotal += (materials[i].price * materials[i].quantity);
        }

        return materialTotal;
    }

    return (
        <Fragment>
            <ul className="total-table">
                <li className="materials">
                    <span
                        className={`dropdown ${!materialsListVisible ? 'closed' : ''}`}
                        onClick={handleMaterialsDropdownClick}
                    >
                        Materials *
                    </span>
                    <span>{formatPrice(materialTotal)}</span>
                </li>
                {
                    (projectMaterials && materialsListVisible) &&
                    <li className="detail-materials">
                        <ul>
                            {
                                Object.keys(projectMaterials).map((materialId) => {
                                    let material = projectMaterials[materialId];
                                    let materialTotal = material.price * material.quantity;
                                    return (
                                        <li key={materialId}>
                                            <span>{material.name}</span>
                                            <span>{formatPrice(materialTotal)}</span>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </li>
                }
                <li className="labor-cost">
                    <LaborCost/>
                </li>
                <li className="total-estimated">
                    <TotalEstimation/>
                </li>
            </ul>
            <span className="advice">
                The amount is an approximation based on actual rates, the contractor must visit the location to confirm the budget!
            </span>
            <span className='materials-disclaimer'>
                * Materials purchased & supplied by the Homeowner.
            </span>
        </Fragment>
    );
}

export default Totals;